'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var $ = jQuery;
var $document = $(document);
var utils = require('./utils.js');
var LeafletOSMMapService = require('./map-services/leaflet-osm-map-service.js');
var MapboxGLMapService = require('./map-services/mapbox-gl-map-service.js');
var Pin = require('./pin.js');
var LocationList = require('./location-list.js');
var MapSamuraiPreloader = require('./preloader.js');
var WeatherControls = require('./weather-controls.js');
var SearchTemperatureMarker = require('./search-temperature-marker.js');

var Map = function () {
	function Map($container, settings) {
		_classCallCheck(this, Map);

		var defaults = {
			strings: window.mapsamurai_script_settings.strings,
			map: {
				id: 0,
				type: 'road',
				mode: 'map',
				center: [0, 0],
				tileset: '',

				background: ''
			},
			zoom: {
				enabled: true,
				zoom: 3
			},
			pins: {
				defaultImage: '',
				pins: []
			},
			cluster: {
				enabled: false
			},
			tooltip: {
				background: [255, 255, 255, 1]
			},
			search: {
				centerOnSearch: true,
				radiusUnitName: 'Miles',
				radiusUnit: 'mi',
				radius: 5,
				radiusInMeters: 0,
				regionBias: ''
			},
			filters: {
				centerOnFilter: true
			},
			routes: []
		};
		this.settings = $.extend(true, {}, defaults, settings);
		this.calculateSearchRadiusInMeters();

		this.$container = $container.first();
		if (!this.$container || !this.$container.length) {
			return;
		}

		this.searchIsSearching = false;
		this.searchLastResult = null;
		this.searchRadiusInMeters = 0;
		this.searchLastClosestPin = null;
		this.introZoomExecuted = false;

		window.MapSamurai.instances.push(this);
		this.$container.data('mapsamurai', this);
		this.$canvas = this.$container.find('.mpfy-map-canvas:first');
		this.$zoomInButton = this.$container.find('.mpfy-zoom-in:first');
		this.$zoomOutButton = this.$container.find('.mpfy-zoom-out:first');
		this.$tagSelect = this.$container.find('.mpfy-tag-select:first');
		this.$filterMultiToggle = this.$container.find('.mpfy-filter-multi-toggle:first');
		this.$filterMultiDropdown = this.$container.find('.mpfy-filter-multi-dropdown:first');
		this.$tagCheckboxes = this.$container.find('.mpfy-tag-checkbox');
		this.$filterSelectAll = this.$container.find('.mpfy-filter-select-all:first');
		this.$filterClearAll = this.$container.find('.mpfy-filter-clear-all:first');
		this.$searchForm = this.$container.find('.mpfy-search-form:first');
		this.$searchFormInput = this.$searchForm.find('.mpfy-search-input:first');
		this.$searchFormButton = this.$searchForm.find('.mpfy-search-button:first');
		this.$searchFormClearButton = this.$searchForm.find('.mpfy-search-clear:first');
		this.$searchRadiusSelect = this.$container.find('select[name="mpsmr_search_radius"]:first');
		this.$locationList = this.$container.find('.mpfy-mll:first');
		this.$geolocateButton = this.$container.find('.mpfy-geolocate:first');

		this.proprietaryData = JSON.parse(this.$container.attr('data-proprietary'));
		this.pins = [];
		this.searchTemperatureMarker = null;

		// Determine if we should use 3D Mapbox or 2D Leaflet
		var is3D = this.settings.map.type && this.settings.map.type.startsWith('3d-');

		if (is3D) {
			try {
				this.mapService = new MapboxGLMapService(this.$canvas, {
					map: {
						background: this.settings.map.background,
						tileset: this.settings.map.tileset
					},
					zoom: {
						enabled: this.settings.zoom.enabled,
						zoom: this.settings.zoom.zoom
					},
					cluster: {
						enabled: this.settings.cluster.enabled
					},
					weather: this.settings.weather
				});
			} catch (error) {
				// Fall back to Leaflet
				this.mapService = new LeafletOSMMapService(this.$canvas, {
					map: {
						background: this.settings.map.background,
						tileset: this.settings.map.tileset
					},
					zoom: {
						enabled: this.settings.zoom.enabled,
						zoom: this.settings.zoom.zoom
					},
					cluster: {
						enabled: this.settings.cluster.enabled
					},
					weather: this.settings.weather
				});
			}
		} else {
			this.mapService = new LeafletOSMMapService(this.$canvas, {
				map: {
					background: this.settings.map.background,
					tileset: this.settings.map.tileset
				},
				zoom: {
					enabled: this.settings.zoom.enabled,
					zoom: this.settings.zoom.zoom
				},
				cluster: {
					enabled: this.settings.cluster.enabled
				},
				weather: this.settings.weather
			});
		}

		if (this.settings.map.mode === 'image') {
			this.mapService.setType('image');
		} else {
			this.mapService.setType(this.settings.map.type);
		}

		this.mapService.setCenter(this.settings.map.center);

		// Only set the initial zoom if intro zoom is NOT enabled
		// If intro zoom is enabled, we'll start from the furthest zoom level
		if (!this.settings.zoom.enableIntroZoom) {
			this.mapService.setZoom(this.settings.zoom.zoom);
		} else {
			// Set to furthest zoom for intro animation
			// For image mode, use -1 to start more zoomed out (map will be smaller)
			// For regular maps, use 1
			var isImageMode = this.settings.map.mode === 'image';
			var startZoom = isImageMode ? -1 : 1;
			this.mapService.setZoom(startZoom);
		}

		// Conditionally initialize preloader based on settings
		if (this.settings.map.enablePreloader) {
			this.preloader = new MapSamuraiPreloader(this.$container, {
				timeout: 30000,
				showProgress: true,
				showStage: true
			});
		} else {
			this.preloader = null;
		}

		this.locationList = this.$locationList.length > 0 ? new LocationList(this.$locationList, this) : null;

		this.addEvents();

		// Choose initialization method based on preloader availability
		if (this.preloader) {
			this.initializeWithPreloader();
		} else {
			this.initializeWithoutPreloader();
		}
	}

	_createClass(Map, [{
		key: 'initializeWithPreloader',
		value: function initializeWithPreloader() {
			var _this = this;

			// Set initial stage
			this.preloader.setStage('initializing');

			// Create loading promises for each stage
			var loadingPromises = {
				tiles: this.waitForTilesLoaded(),
				pins: this.addPinsWithPreloader(),
				clusters: this.waitForClustersReady(),
				routes: this.settings.zoom.enableIntroZoom ? Promise.resolve() : this.addRoutesWithPreloader(), // Skip routes if intro zoom enabled
				list: this.initializeLocationListWithPreloader(),
				filters: this.initializeFiltersWithPreloader()
			};

			// Start loading immediately
			_this.preloader.setStage('loading_tiles');

			// Execute loading stages properly
			loadingPromises.tiles.then(function () {
				_this.preloader.setStage('loading_pins');
				return loadingPromises.pins;
			}).then(function () {
				if (_this.settings.cluster.enabled) {
					_this.preloader.setStage('loading_clusters');
					return loadingPromises.clusters;
				}
				return Promise.resolve();
			}).then(function () {
				_this.preloader.setStage('loading_routes');
				return loadingPromises.routes;
			}).then(function () {
				_this.preloader.setStage('loading_list');
				return loadingPromises.list;
			}).then(function () {
				_this.preloader.setStage('loading_filters');
				return loadingPromises.filters;
			}).then(function () {
				_this.preloader.setStage('finalizing');

				// Ensure map is fully rendered
				if (_this.mapService.map && _this.mapService.map.invalidateSize) {
					_this.mapService.map.invalidateSize();
				}

				// Final setup
				setTimeout(function () {
					_this.preloader.complete();

					// Initialize weather controls if enabled
					_this.initializeWeatherControls();

					// Execute intro zoom if enabled
					if (_this.settings.zoom.enableIntroZoom) {
						_this.executeIntroZoom();
					} else {}

					_this.$container.trigger('mapsamurai.map.loaded', _this);
				}, 300);
			}).catch(function (error) {
				_this.preloader.showError('Failed to load map: ' + error.message, true);
			});
		}
	}, {
		key: 'initializeWithoutPreloader',
		value: function initializeWithoutPreloader() {
			var _this = this;

			// Initialize all components immediately without preloader stages
			Promise.all([this.addPinsWithoutPreloader(), this.addRoutesWithoutPreloader(), this.initializeLocationListWithoutPreloader(), this.initializeFiltersWithoutPreloader()]).then(function () {
				// Ensure map is fully rendered
				if (_this.mapService.map && _this.mapService.map.invalidateSize) {
					_this.mapService.map.invalidateSize();
				}

				// Final setup without delay
				// Initialize weather controls if enabled
				_this.initializeWeatherControls();

				// Execute intro zoom if enabled
				if (_this.settings.zoom.enableIntroZoom) {
					_this.executeIntroZoom();
				} else {}

				_this.$container.trigger('mapsamurai.map.loaded', _this);
			}).catch(function (error) {});
		}
	}, {
		key: 'waitForTilesLoaded',
		value: function waitForTilesLoaded() {
			var _this = this;
			return new Promise(function (resolve) {
				// For Leaflet maps, wait for tiles to actually load
				if (_this.mapService.map) {
					var tilesLoaded = false;
					var loadTimeout = void 0;

					// Handler for when tiles are loaded
					var onTilesLoaded = function onTilesLoaded() {
						if (!tilesLoaded) {
							tilesLoaded = true;
							clearTimeout(loadTimeout);
							// Give a bit more time for rendering
							setTimeout(resolve, 200);
						}
					};

					// Listen for tile load events
					if (_this.mapService.map.on) {
						_this.mapService.map.on('load', onTilesLoaded);
						_this.mapService.map.on('tilelayersload', onTilesLoaded);

						// Also check if already loaded
						if (_this.mapService.map._loaded) {
							onTilesLoaded();
							return;
						}
					}

					// Fallback timeout
					loadTimeout = setTimeout(function () {
						if (!tilesLoaded) {
							onTilesLoaded();
						}
					}, 5000);
				} else {
					// For other map services
					setTimeout(resolve, 1000);
				}
			});
		}
	}, {
		key: 'addPinsWithPreloader',
		value: function addPinsWithPreloader() {
			// Use the original addPins method but return it as a promise
			return this.addPins();
		}
	}, {
		key: 'waitForClustersReady',
		value: function waitForClustersReady() {
			var _this = this;

			// Use the map service's cluster waiting method if available
			if (_this.mapService.waitForClustersReady) {
				return _this.mapService.waitForClustersReady();
			}

			// Fallback for other map services
			return new Promise(function (resolve) {
				if (!_this.settings.cluster.enabled) {
					resolve();
					return;
				}

				setTimeout(function () {
					if (_this.mapService.refreshClusters) {
						_this.mapService.refreshClusters();
					}
					resolve();
				}, 500);
			});
		}
	}, {
		key: 'addRoutesWithPreloader',
		value: function addRoutesWithPreloader() {
			var _this = this;
			return new Promise(function (resolve) {
				try {
					_this.addRoutes();
					resolve();
				} catch (error) {
					resolve(); // Don't fail the entire loading process
				}
			});
		}
	}, {
		key: 'initializeLocationListWithPreloader',
		value: function initializeLocationListWithPreloader() {
			var _this = this;
			return new Promise(function (resolve) {
				if (_this.locationList && _this.locationList.initialize) {
					_this.locationList.initialize().then(resolve).catch(function () {
						return resolve();
					});
				} else {
					resolve();
				}
			});
		}
	}, {
		key: 'initializeFiltersWithPreloader',
		value: function initializeFiltersWithPreloader() {
			var _this = this;
			return new Promise(function (resolve) {
				// Initialize any filter-related functionality
				if (_this.$tagSelect.length > 0) {
					setTimeout(resolve, 100);
				} else {
					resolve();
				}
			});
		}

		// Non-preloader versions of initialization methods

	}, {
		key: 'addPinsWithoutPreloader',
		value: function addPinsWithoutPreloader() {
			return this.addPins();
		}
	}, {
		key: 'addRoutesWithoutPreloader',
		value: function addRoutesWithoutPreloader() {
			var _this = this;
			return new Promise(function (resolve) {
				try {
					_this.addRoutes();
					resolve();
				} catch (error) {
					resolve(); // Don't fail the entire loading process
				}
			});
		}
	}, {
		key: 'initializeLocationListWithoutPreloader',
		value: function initializeLocationListWithoutPreloader() {
			var _this = this;
			return new Promise(function (resolve) {
				if (_this.locationList && _this.locationList.initialize) {
					_this.locationList.initialize().then(resolve).catch(function () {
						return resolve();
					});
				} else {
					resolve();
				}
			});
		}
	}, {
		key: 'initializeFiltersWithoutPreloader',
		value: function initializeFiltersWithoutPreloader() {
			var _this = this;
			return new Promise(function (resolve) {
				// Initialize any filter-related functionality immediately
				if (_this.$tagSelect.length > 0) {
					resolve();
				} else {
					resolve();
				}
			});
		}
	}, {
		key: 'calculateSearchRadiusInMeters',
		value: function calculateSearchRadiusInMeters() {
			this.settings.search.radiusInMeters = utils.unit2meters(this.settings.search.radius, this.settings.search.radiusUnit);
		}
	}, {
		key: 'addRoutes',
		value: function addRoutes() {
			if (!this.settings.routes || this.settings.routes.length === 0) {
				return;
			}

			// Check if we're using Mapbox (3D) or Leaflet (2D)
			if (this.mapService.addRoutes) {
				// Use the map service's addRoutes method (works for both Leaflet and Mapbox)
				this.mapService.addRoutes(this.settings.routes);
			} else {
				// Fallback to original Leaflet implementation
				this.addLeafletRoutes();
			}
		}
	}, {
		key: 'addLeafletRoutes',
		value: function addLeafletRoutes() {
			var _this2 = this;

			// Add CSS to hide routing control panels
			if (!document.getElementById('mapsamurai-route-styles')) {
				var style = document.createElement('style');
				style.id = 'mapsamurai-route-styles';
				style.textContent = '\n\t\t\t.leaflet-routing-container { \n\t\t\t\tdisplay: none !important; \n\t\t\t}\n\t\t\t.leaflet-routing-alternatives-container { \n\t\t\t\tdisplay: none !important; \n\t\t\t}\n\t\t\t.leaflet-control-container .leaflet-routing-container {\n\t\t\t\tdisplay: none !important;\n\t\t\t}\n\t\t';
				document.head.appendChild(style);
			}

			this.settings.routes.forEach(function (route) {
				var latlngs = route.waypoints.map(function (wp) {
					return L.latLng(wp.lat, wp.lng);
				});
				if (!latlngs.length) return;

				if (route.type === 'custom') {
					L.polyline(latlngs, {
						color: route.color || '#3a6fac',
						weight: parseInt(route.width) || 5
					}).addTo(_this2.mapService.map);
				} else if (route.type === 'automatic' && latlngs.length >= 2) {
					var plan = L.Routing.plan(latlngs, {
						createMarker: function createMarker() {
							return null;
						}
					});
					L.Routing.control({
						plan: plan,
						lineOptions: {
							styles: [{
								color: route.color || '#3a6fac',
								weight: parseInt(route.width) || 5
							}]
						},
						addWaypoints: false,
						draggableWaypoints: false,
						routeWhileDragging: false,
						fitSelectedRoutes: false,
						show: false,
						createMarker: function createMarker() {
							return null;
						},
						router: L.Routing.mapbox('pk.eyJ1IjoianNlYXJzMzEiLCJhIjoiY21hYmNnMnJjMmF3MTJycHpwdHM4MmExMiJ9.MuKtofSbgkg5S5BtdrtMbw')
					}).addTo(_this2.mapService.map);
				}
			});
		}
	}, {
		key: 'getProprietaryData',
		value: function getProprietaryData(key) {
			if (typeof this.proprietaryData[key] == 'undefined') {
				return null;
			}
			return this.proprietaryData[key];
		}
	}, {
		key: 'addPins',
		value: function addPins() {
			var _this3 = this;

			for (var i = 0; i < this.settings.pins.pins.length; i++) {
				var pinModel = this.settings.pins.pins[i];

				var tooltipClasses = ['mpfy-tooltip-map-' + this.settings.map.id, 'mpfy-tooltip-image-orientation-' + this.settings.tooltip.imageOrientation];
				if (pinModel.thumbnail) {
					tooltipClasses.push('mpfy-tooltip-with-thumbnail');
				}
				var pin = new Pin(pinModel, {
					classes: tooltipClasses.join(' '),
					background: this.settings.tooltip.background,
					content: pinModel.tooltipContent,
					closeBehavior: pinModel.tooltipCloseBehavior,
					animate: pinModel.animateTooltips
				}, {
					hideInitially: !!this.settings.pins.hideInitially
				});
				this.pins.push(pin);
			}

			// Add pins to map service first
			return this.mapService.addPins(this.pins).then(function () {
				// After pins are added, set up any animated pins
				// Add a longer delay to ensure all pins (especially with thumbnails and clustering) are fully processed
				var delay = _this3.settings.cluster.enabled ? 500 : 100;
				setTimeout(function () {
					_this3.setupAnimatedPins();
				}, delay);
			});
		}
	}, {
		key: 'setupAnimatedPins',
		value: function setupAnimatedPins() {
			var _this4 = this;

			if (!this.mapService.supportsRouteAnimation || !this.mapService.supportsRouteAnimation()) {
				return;
			}

			// Check each location pin for animation settings
			this.pins.forEach(function (pin) {
				var pinModel = pin.model;

				// Check if this pin should be animated
				if (pinModel.animateOnRoute === 'yes' && pinModel.selectedRoute && pinModel.selectedRoute !== '') {

					// Check if we can get the marker for this pin
					var marker = _this4.mapService.getPinMarker(pin);
					if (!marker) {
						// If marker not found immediately (common with thumbnails or clustering), retry after delay

						setTimeout(function () {
							marker = _this4.mapService.getPinMarker(pin);
							if (!marker) {
								// Final attempt with longer delay
								setTimeout(function () {
									marker = _this4.mapService.getPinMarker(pin);
									if (!marker) {
										// Debug: Print all marker IDs
										_this4.mapService.markers.forEach(function (m, i) {});
										return;
									}
									_this4.proceedWithAnimation(pin, pinModel);
								}, 500);
								return;
							}
							_this4.proceedWithAnimation(pin, pinModel);
						}, 200);
						return;
					}

					_this4.proceedWithAnimation(pin, pinModel);
				}
			});
		}
	}, {
		key: 'proceedWithAnimation',
		value: function proceedWithAnimation(pin, pinModel) {
			// Find the route data for this pin
			var routeData = this.findRouteById(pinModel.selectedRoute);
			if (routeData && routeData.waypoints && routeData.waypoints.length >= 2) {

				this.setupLocationAnimation(pin, routeData);
			} else {}
		}
	}, {
		key: 'setupLocationAnimation',
		value: function setupLocationAnimation(pin, routeData) {
			var animationOptions = {
				speed: parseInt(pin.model.animationSpeed) || 30,
				direction: pin.model.animationDirection || 'both',
				delay: parseFloat(pin.model.animationDelay) || 0,
				pauseOnHover: true,
				loop: true
			};

			if (routeData.type === 'custom') {
				// For custom routes, use the waypoints directly
				this.mapService.addAnimatedPin(pin, routeData.waypoints, animationOptions);
			} else if (routeData.type === 'automatic') {
				// For automatic routes, we need to get the calculated route path
				this.setupAutomaticLocationAnimation(pin, routeData, animationOptions);
			}
		}
	}, {
		key: 'setupAutomaticLocationAnimation',
		value: function setupAutomaticLocationAnimation(pin, routeData, animationOptions) {
			var _this5 = this;

			// Check if we're using Leaflet or Mapbox GL - only Leaflet supports Leaflet Routing Machine
			var isLeaflet = this.mapService.constructor.name === 'LeafletOSMMapService';

			if (!isLeaflet) {
				// For Mapbox GL, fallback to straight-line animation between waypoints
				this.mapService.addAnimatedPin(pin, routeData.waypoints, animationOptions);
				return;
			}

			var latlngs = routeData.waypoints.map(function (wp) {
				return L.latLng(wp.lat, wp.lng);
			});

			// Create a temporary routing control to get the calculated route (Leaflet only)
			var plan = L.Routing.plan(latlngs, {
				createMarker: function createMarker() {
					return null;
				}
			});

			var routingControl = L.Routing.control({
				plan: plan,
				lineOptions: {
					styles: [{
						color: 'transparent', // Make it invisible since we only want the path data
						weight: 0
					}]
				},
				addWaypoints: false,
				draggableWaypoints: false,
				routeWhileDragging: false,
				fitSelectedRoutes: false,
				show: false,
				createMarker: function createMarker() {
					return null;
				},
				router: L.Routing.mapbox('pk.eyJ1IjoianNlYXJzMzEiLCJhIjoiY21hYmNnMnJjMmF3MTJycHpwdHM4MmExMiJ9.MuKtofSbgkg5S5BtdrtMbw')
			});

			// Listen for when the route is calculated
			routingControl.on('routesfound', function (e) {

				if (e.routes && e.routes.length > 0) {
					// Get the coordinates from the calculated route
					var routeCoordinates = e.routes[0].coordinates;

					// Convert to the format expected by the animation system
					var animationWaypoints = routeCoordinates.map(function (coord) {
						return {
							lat: coord.lat,
							lng: coord.lng
						};
					});

					// Remove the temporary routing control since we only needed the path
					_this5.mapService.map.removeControl(routingControl);

					// Set up animation with the calculated path for existing location pin
					_this5.mapService.addAnimatedPin(pin, animationWaypoints, animationOptions);
				} else {
					// Fallback to direct waypoints if routing fails
					_this5.mapService.addAnimatedPin(pin, routeData.waypoints, animationOptions);
				}
			});

			// Handle routing errors
			routingControl.on('routingerror', function (e) {
				// Remove the failed routing control
				_this5.mapService.map.removeControl(routingControl);
				// Fallback to direct waypoints
				_this5.mapService.addAnimatedPin(pin, routeData.waypoints, animationOptions);
			});

			// Add the routing control temporarily to trigger route calculation
			routingControl.addTo(this.mapService.map);
		}
	}, {
		key: 'findRouteById',
		value: function findRouteById(routeId) {
			// Search through available routes to find the one with matching ID
			if (!this.settings.routes || !Array.isArray(this.settings.routes)) {
				return null;
			}

			// Convert routeId to number for comparison since it might be a string
			var targetId = parseInt(routeId);

			for (var i = 0; i < this.settings.routes.length; i++) {
				var route = this.settings.routes[i];
				// Compare both as numbers and strings to handle type mismatches
				if (route.id == routeId || route.id === targetId || route.routeId == routeId || route.routeId === targetId) {
					return route;
				}
			}

			return null;
		}
	}, {
		key: 'addEvents',
		value: function addEvents() {
			var _this6 = this;

			var _this = this;

			// Listen for map clicks to show temperature
			$(_this.mapService).on('mapsamurai.map.clicked', function (e, data) {
				_this.handleMapClickTemperature(data.lat, data.lng);
			});

			_this.tagSelectEvent = function () {
				var tagId = $(this).val();
				_this.filterByTag(tagId);
			};

			if (_this.$tagSelect.length > 0) {
				_this.$tagSelect.off('change').on('change', _this.tagSelectEvent);
				_this.$tagSelect.trigger('change');
			}

			// Multi-select filter events
			if (_this.$filterMultiToggle.length > 0) {
				var $filterMultiContainer = _this.$container.find('.mpfy-filter-multi:first');

				_this.$filterMultiToggle.on('click', function (e) {
					e.preventDefault();
					_this.$filterMultiDropdown.toggle();
					$filterMultiContainer.toggleClass('open');
				});

				// Close dropdown when clicking outside
				$(document).on('click', function (e) {
					if (!$(e.target).closest('.mpfy-filter-multi').length) {
						_this.$filterMultiDropdown.hide();
						$filterMultiContainer.removeClass('open');
					}
				});

				// Handle checkbox changes
				_this.$tagCheckboxes.on('change', function () {
					var selectedTags = [];
					_this.$tagCheckboxes.filter(':checked').each(function () {
						selectedTags.push(parseInt($(this).val()));
					});

					_this.filterByTags(selectedTags);

					// Update toggle label
					if (selectedTags.length === 0) {
						_this.$filterMultiToggle.find('.mpfy-filter-multi-label').text(_this.$filterMultiToggle.data('default-label') || 'Default View');
					} else if (selectedTags.length === 1) {
						var checkedCheckbox = _this.$tagCheckboxes.filter(':checked').first();
						var labelText = checkedCheckbox.closest('label').find('span').text();
						_this.$filterMultiToggle.find('.mpfy-filter-multi-label').text(labelText);
					} else {
						_this.$filterMultiToggle.find('.mpfy-filter-multi-label').text(selectedTags.length + ' filters selected');
					}
				});

				// Select All button
				_this.$filterSelectAll.on('click', function (e) {
					e.preventDefault();
					_this.$tagCheckboxes.prop('checked', true).trigger('change');
				});

				// Clear All button
				_this.$filterClearAll.on('click', function (e) {
					e.preventDefault();
					_this.$tagCheckboxes.prop('checked', false).trigger('change');
				});

				// Store default label for later use
				_this.$filterMultiToggle.data('default-label', _this.$filterMultiToggle.find('.mpfy-filter-multi-label').text());
			}

			// Handle clicking on filter list items in multi-select mode
			_this.$container.find('.mpfy-tl-item-multi').on('click', function (e) {
				e.preventDefault();
				var $item = $(this);
				var tagId = parseInt($item.attr('data-tag-id') || 0);

				// Toggle the corresponding dropdown checkbox
				if (_this.$tagCheckboxes.length > 0) {
					var $checkbox = _this.$tagCheckboxes.filter('[value="' + tagId + '"]');
					$checkbox.prop('checked', !$checkbox.prop('checked')).trigger('change');
				}
			});

			// Handle Default View reset button in multi-select mode
			_this.$container.find('.mpfy-tl-item-reset').on('click', function (e) {
				e.preventDefault();
				// Uncheck all dropdown checkboxes
				_this.$tagCheckboxes.prop('checked', false);
				// Reset to show all pins
				_this.filterByTags([]);
			});

			$document.one('ready', function () {
				$('body').trigger('mapsamurai.map.created', _this);

				if (_this.$tagSelect.length > 0) {
					_this.$tagSelect.on('change', _this.tagSelectEvent);
				}

				if (_this.$searchRadiusSelect.length > 0) {
					_this.$searchRadiusSelect.on('change', function () {
						_this.settings.search.radius = parseInt($(this).val());
						_this.calculateSearchRadiusInMeters();
					}).trigger('change');
				}
			});

			$(window).on('load resize orientationchange mapsamurai.redraw', function () {
				var controls = _this.$container.find('.mpfy-controls:first');
				var breakingWidth = 650;
				var controlsWidth = controls.width();
				controls.toggleClass('mpfy-controls-mobile', controlsWidth <= breakingWidth);
				_this.$container.toggleClass('mpfy-layout-mobile', controlsWidth <= breakingWidth);
			});

			if ("ontouchstart" in window || navigator.msMaxTouchPoints) {
				this.$container.addClass('mpfy-touch-device');
			}

			this.$searchFormClearButton.click(function (e) {
				e.preventDefault();
				_this.clearSearch();
			});

			this.$searchFormInput.bind('keyup change', function (e) {
				_this.$searchFormClearButton.toggle($(this).val().length > 0);
			});

			this.$zoomInButton.click(function (e) {
				e.preventDefault();
				_this.mapService.setZoom(_this.mapService.getZoom() + 1);
			});

			this.$zoomOutButton.click(function (e) {
				e.preventDefault();
				_this.mapService.setZoom(Math.max(0, _this.mapService.getZoom() - 1));
			});

			this.$container.find('.mpfy-selecter-wrap select').selecter();

			this.$searchForm.submit(function (e) {
				e.preventDefault();
				var recenterOnBlank = typeof e.mapsamurai == 'undefined' || typeof e.mapsamurai.recenterOnBlank == 'undefined' ? true : e.mapsamurai.recenterOnBlank;

				var query = _this.$searchFormInput.val().toLowerCase();
				_this.search(query, recenterOnBlank);
			});

			this.$geolocateButton.on('click', function (e) {
				e.preventDefault();
				_this6.mapService.locate().then(function () {
					_this.$container.trigger('mapsamurai.useMyLocation.ended');
				});
			});
		}
	}, {
		key: 'getPinById',
		value: function getPinById(pinId) {
			for (var i = 0; i < this.pins.length; i++) {
				var pin = this.pins[i];
				if (pin.model.id == pinId) {
					return pin;
				}
			}
			return null;
		}
	}, {
		key: 'getVisiblePins',
		value: function getVisiblePins() {
			return this.pins.filter(function (pin) {
				return pin.isVisible();
			});
		}
	}, {
		key: 'filter',
		value: function filter(visibilityCondition, filterCallback) {
			var baseVisibility = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

			var _this = this;
			var promises = [];
			for (var i = this.pins.length - 1; i >= 0; i--) {
				var pin = this.pins[i];
				pin.setVisibility(visibilityCondition, filterCallback(pin));
				pin.setVisibility('base', baseVisibility);
				promises.push(this.mapService.updatePinVisibility(pin));
			}
			return Promise.all(promises).then(function () {
				// Refresh clusters after filtering to ensure correct counts
				if (_this.mapService.refreshClusters) {
					_this.mapService.refreshClusters();
				}
				_this.$container.trigger('mapsamurai.pins.visibilityUpdated', visibilityCondition);
			});
		}
	}, {
		key: 'filterByTag',
		value: function filterByTag(tagId) {
			var _this = this;
			tagId = parseInt(tagId);
			_this.$tagSelect.off('change', _this.tagSelectEvent);
			this.$tagSelect.val(tagId).trigger('change');
			_this.$tagSelect.on('change', _this.tagSelectEvent);

			return Promise.resolve().then(function () {
				if (tagId <= 0) {
					return _this.filter('tag', function (pin) {
						return true;
					}, !_this.settings.pins.hideInitially).then(function () {
						return _this.mapService.setCenter(_this.settings.map.center);
					}) // always center first
					.then(function () {
						// Only set zoom if intro zoom is disabled or already executed
						if (!_this.settings.zoom.enableIntroZoom || _this.introZoomExecuted) {
							return _this.mapService.setZoom(_this.settings.zoom.zoom);
						}
					}).then(function () {
						return _this.mapService.setCenter(_this.settings.map.center);
					}); // center again after zoom to avoid rounding inaccuracies
				}

				return _this.filter('tag', function (pin) {
					return typeof pin.model.tags[tagId.toString()] !== 'undefined';
				}).then(function () {
					if (_this.settings.filters.centerOnFilter) {
						var visiblePins = _this.getVisiblePins();
						return _this.mapService.fitPins(visiblePins);
					}
					return Promise.resolve();
				});
			}).then(function () {
				_this.$container.trigger('mapsamurai.filter.ended', {
					tagId: tagId
				});
			});
		}
	}, {
		key: 'filterByTags',
		value: function filterByTags(tagIds) {
			var _this = this;

			return Promise.resolve().then(function () {
				// If no tags selected, show all pins
				if (!tagIds || tagIds.length === 0) {
					return _this.filter('tag', function (pin) {
						return true;
					}, !_this.settings.pins.hideInitially).then(function () {
						return _this.mapService.setCenter(_this.settings.map.center);
					}) // always center first
					.then(function () {
						// Only set zoom if intro zoom is disabled or already executed
						if (!_this.settings.zoom.enableIntroZoom || _this.introZoomExecuted) {
							return _this.mapService.setZoom(_this.settings.zoom.zoom);
						}
					}).then(function () {
						return _this.mapService.setCenter(_this.settings.map.center);
					}); // center again after zoom to avoid rounding inaccuracies
				}

				// Filter pins that match ANY of the selected tags (OR logic)
				return _this.filter('tag', function (pin) {
					return tagIds.some(function (tagId) {
						return typeof pin.model.tags[tagId.toString()] !== 'undefined';
					});
				}).then(function () {
					if (_this.settings.filters.centerOnFilter) {
						var visiblePins = _this.getVisiblePins();
						return _this.mapService.fitPins(visiblePins);
					}
					return Promise.resolve();
				});
			}).then(function () {
				_this.updateFilterListActiveStates();
				_this.$container.trigger('mapsamurai.filter.ended', {
					tagIds: tagIds
				});
			});
		}
	}, {
		key: 'updateFilterListActiveStates',
		value: function updateFilterListActiveStates() {
			var _this = this;
			var selectedTags = [];

			// Get selected tags from dropdown checkboxes only
			var $checkboxes = _this.$container.find('.mpfy-tag-checkbox:checked');
			$checkboxes.each(function () {
				var val = parseInt($(this).val());
				if (val !== 0 && selectedTags.indexOf(val) === -1) {
					selectedTags.push(val);
				}
			});

			// Update filter list visual states
			_this.$container.find('.mpfy-tl-item').each(function () {
				var $item = $(this);
				var tagId = parseInt($item.attr('data-tag-id') || 0);

				// Skip Default View - it's always visible as a reset button
				if ($item.hasClass('mpfy-tl-item-reset')) {
					$item.removeClass('mpfy-tl-item-active');
					return;
				}

				if (tagId === 0 && selectedTags.length === 0) {
					$item.addClass('mpfy-tl-item-active');
				} else if (selectedTags.indexOf(tagId) !== -1) {
					$item.addClass('mpfy-tl-item-active');
				} else {
					$item.removeClass('mpfy-tl-item-active');
				}
			});
		}
	}, {
		key: 'requestSearchResults',
		value: function requestSearchResults(query, recenterOnBlank) {
			var _this = this;
			if (_this.searchIsSearching) {
				return Promise.reject('busy');
			}

			_this.searchLastResult = null;
			if (query.length === 0) {
				return _this.filter('search', function (pin) {
					return true;
				}).then(function () {
					if (recenterOnBlank) {
						return _this.mapService.setCenter(_this.settings.map.center);
					}
					return Promise.resolve();
				});
			}

			if (_this.settings.map.mode === 'image') {
				return _this.filter('search', function (pin) {
					return pin.model.city.indexOf(query) !== -1 || pin.model.city.indexOf(query) !== -1;
				}).then(function () {
					if (_this.getVisiblePins().length === 0) {
						utils.showSearchPopup(_this, _this.settings.strings.no_search_results);
					}
					return Promise.resolve();
				});
			}

			_this.searchIsSearching = true;
			return _this.mapService.geocode(query + ', ' + _this.settings.search.regionBias).then(function (results) {
				if (results.length === 0) {
					utils.showSearchPopup(_this, _this.settings.strings.search_geolocation_failure);
					return Promise.resolve();
				}

				var result = results[0];
				_this.searchLastResult = result;

				var filteredPins = _this.mapService.getPinsWithinRange(result.lat, result.lng, _this.settings.search.radiusInMeters);

				return _this.filter('search', function (pin) {
					return filteredPins.indexOf(pin) !== -1;
				}).then(function () {
					if (_this.getVisiblePins().length === 0) {
						_this.searchLastClosestPin = _this.mapService.getPinClosestTo(result.lat, result.lng);
						utils.showSearchPopup(_this, _this.settings.strings.no_search_results_with_closest);
					}

					return Promise.resolve();
				});
			}).catch(function (error) {}).then(function () {
				_this.searchIsSearching = false;
				return Promise.resolve();
			});
		}
	}, {
		key: 'search',
		value: function search(query, recenterOnBlank) {
			var _this = this;
			return _this.requestSearchResults(query, recenterOnBlank).then(function () {
				var visiblePins = _this.getVisiblePins();
				if (visiblePins.length > 0 && _this.settings.search.centerOnSearch) {
					return _this.mapService.fitPins(visiblePins);
				}
				return Promise.resolve();
			}).then(function () {
				_this.$container.trigger('mapsamurai.search.ended', {
					'query': query
				});
				return Promise.resolve();
			}).catch(function (error) {
				if (error !== 'busy') {
					return Promise.reject(error);
				}
			});
		}
	}, {
		key: 'clearSearch',
		value: function clearSearch(recenterOnBlank) {
			recenterOnBlank = typeof recenterOnBlank == 'undefined' ? true : recenterOnBlank;
			this.$searchFormInput.val('').trigger('change');
			return this.search('', recenterOnBlank);
		}
	}, {
		key: 'initializeWeatherControls',
		value: function initializeWeatherControls() {
			// Only initialize if weather is enabled and interface is enabled
			if (!this.settings.weather || !this.settings.weather.enabled || !this.settings.weather.interfaceEnabled) {
				return;
			}

			// Initialize the WeatherControls, pass 'this' so it can call removeTemperatureMarker
			this.weatherControls = new WeatherControls(this.$container, this.mapService, this.settings.weather, this);
		}
	}, {
		key: 'handleMapClickTemperature',
		value: function handleMapClickTemperature(lat, lng) {
			var _this = this;

			console.log('Map clicked at:', lat, lng);
			console.log('Weather settings:', _this.settings.weather);
			console.log('Weather controls:', _this.weatherControls);
			console.log('Selected layer:', _this.weatherControls ? _this.weatherControls.selectedLayer : 'none');

			// Check if temperature layer is currently active
			if (!_this.settings.weather || !_this.settings.weather.enabled) {
				console.log('Weather not enabled in settings');
				return;
			}

			if (!_this.weatherControls || !_this.weatherControls.selectedLayer) {
				console.log('No weather controls or no selected layer');
				return;
			}

			if (_this.weatherControls.selectedLayer !== 'temp_new') {
				console.log('Temperature layer not selected, current:', _this.weatherControls.selectedLayer);
				return;
			}

			console.log('Creating temperature marker...');

			// Close any open popups or tooltips
			if (window.MapSamurai) {
				if (window.MapSamurai.closePopup) {
					window.MapSamurai.closePopup();
				}
				if (window.MapSamurai.closeTooltips) {
					window.MapSamurai.closeTooltips();
				}
			}

			// Fade out and remove existing marker
			if (_this.searchTemperatureMarker) {
				_this.searchTemperatureMarker.remove(); // Now includes fade-out animation
				// Wait for fade-out to complete before creating new marker
				setTimeout(function () {
					_this.createTemperatureMarkerAt(lat, lng);
				}, 300); // Match fade-out duration
			} else {
				// No existing marker, create immediately
				_this.createTemperatureMarkerAt(lat, lng);
			}
		}
	}, {
		key: 'createTemperatureMarkerAt',
		value: function createTemperatureMarkerAt(lat, lng) {
			var _this = this;

			console.log('createTemperatureMarkerAt called with:', lat, lng);

			// Create marker at clicked coordinates
			var coordinates = { lat: lat, lng: lng };

			_this.searchTemperatureMarker = new SearchTemperatureMarker(_this.mapService, coordinates);

			console.log('Temperature marker created:', _this.searchTemperatureMarker);

			// Get temperature format from settings (default to fahrenheit)
			var temperatureFormat = _this.settings.weather && _this.settings.weather.temperatureFormat ? _this.settings.weather.temperatureFormat : 'fahrenheit';

			// Fetch and display temperature
			_this.mapService.fetchCurrentTemperature(lat, lng, temperatureFormat).then(function (temperature) {
				console.log('Temperature received:', temperature);
				if (_this.searchTemperatureMarker) {
					_this.searchTemperatureMarker.update(temperature);
					console.log('Temperature marker updated');
				}
			}).catch(function (error) {
				console.error('Could not fetch temperature:', error);
			});
		}
	}, {
		key: 'removeTemperatureMarker',
		value: function removeTemperatureMarker() {
			var _this = this;
			if (_this.searchTemperatureMarker) {
				_this.searchTemperatureMarker.remove();
				_this.searchTemperatureMarker = null;
			}
		}
	}, {
		key: 'executeIntroZoom',
		value: function executeIntroZoom() {
			var _this7 = this;

			var _this = this;

			// Only execute once
			if (this.introZoomExecuted) {
				return;
			}
			this.introZoomExecuted = true;

			// Skip for 3D maps (Mapbox GL)
			var isLeaflet = this.mapService.constructor.name === 'LeafletOSMMapService';
			if (!isLeaflet) {
				return;
			}

			var targetZoom = this.settings.zoom.zoom;
			var duration = this.settings.zoom.introZoomDuration * 1000; // Convert to milliseconds

			// Determine the starting zoom level based on map mode
			// Image mode: use -1 for more zoomed out start (smaller image)
			// Regular maps: use 1 for zoomed out start
			var isImageMode = this.settings.map.mode === 'image';
			var startZoom = isImageMode ? -1 : 1;

			// Get current zoom to verify it's at start position
			var currentZoom = this.mapService.getZoom();

			// If we're already at target zoom, don't animate
			if (Math.abs(currentZoom - targetZoom) < 0.1) {
				return;
			}

			if (isLeaflet && this.mapService.map) {
				// For Leaflet, use flyTo for smooth animation
				var map = this.mapService.map;

				// Small delay to ensure map is ready
				setTimeout(function () {
					map.flyTo(_this7.settings.map.center, targetZoom, {
						duration: duration / 1000, // flyTo expects duration in seconds
						easeLinearity: 0.25
					});

					// Add routes after animation completes
					setTimeout(function () {
						_this.addRoutesWithPreloader();
					}, duration + 100); // Wait for animation plus small buffer
				}, 200);
			} else if (!isLeaflet && this.mapService.map) {
				// For Mapbox GL
				var _map = this.mapService.map;

				// Small delay to ensure map is ready, then animate
				setTimeout(function () {
					_map.easeTo({
						center: _this7.settings.map.center,
						zoom: targetZoom,
						duration: duration,
						easing: function easing(t) {
							return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
						} // ease-in-out
					});

					// Add routes after animation completes
					setTimeout(function () {
						_this.addRoutesWithPreloader();
					}, duration + 100); // Wait for animation plus small buffer
				}, 200); // Small delay to ensure map is fully ready
			} else {
				// Fallback for other map services or if map is not ready
				// Simple animation using requestAnimationFrame
				var startTime = Date.now();
				var zoomDiff = targetZoom - startZoom;

				var animate = function animate() {
					var elapsed = Date.now() - startTime;
					var progress = Math.min(elapsed / duration, 1);

					// Use easing function for smooth animation
					var easeInOutQuad = function easeInOutQuad(t) {
						return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
					};
					var easedProgress = easeInOutQuad(progress);

					var currentZoom = startZoom + zoomDiff * easedProgress;
					_this7.mapService.setZoom(currentZoom);

					if (progress < 1) {
						requestAnimationFrame(animate);
					} else {
						// Ensure we end exactly at the target zoom
						_this7.mapService.setZoom(targetZoom);
						// Re-center to ensure accuracy
						_this7.mapService.setCenter(_this7.settings.map.center);

						// Add routes after animation completes
						_this.addRoutesWithPreloader();
					}
				};

				requestAnimationFrame(animate);
			}
		}
	}]);

	return Map;
}();

module.exports = Map;


//////////////////
// WEBPACK FOOTER
// ./assets/js/src/public/map.js
// module id = 13
// module chunks = 0